import { useState } from 'react';

import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { T } from 'react-translator-component';

/**
 * Seção minimizável do módulo. A escolha fica no navegador de quem está vendo (conveniência, não
 * dado): sem storage, só volta expandida na próxima vez.
 */
const readCollapsed = (key: string): boolean => {
  try {
    return localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
};

const saveCollapsed = (key: string, collapsed: boolean) => {
  try {
    localStorage.setItem(key, collapsed ? '1' : '0');
  } catch {
    // Sem storage (aba anônima, bloqueio): só não lembra na próxima vez.
  }
};

export const useCollapsed = (key: string): [boolean, () => void] => {
  const [collapsed, setCollapsed] = useState(() => readCollapsed(key));
  const toggle = () => {
    saveCollapsed(key, !collapsed);
    setCollapsed(!collapsed);
  };
  return [collapsed, toggle];
};

export const CollapseToggle = ({ collapsed, onToggle }: { collapsed: boolean; onToggle: () => void }) => (
  <Button
    type="text"
    size="small"
    icon={collapsed ? <DownOutlined /> : <UpOutlined />}
    aria-expanded={!collapsed}
    onClick={onToggle}
  >
    {collapsed ? T('Expand') : T('Minimize')}
  </Button>
);
